// POM-6086 - the reason an operator gives when a receipt's lot number is already in inventory.
//
// The same manufacturer lot legitimately arrives across two shipments and legitimately sits at
// two facilities, so the repeat is never blocked, nothing is merged and there is no override.
// What is required is this: on-hand for that lot rises a second time, and nothing else on the row
// says why. The system does not infer which of the three it is, because nothing it can see
// distinguishes them.
//
// Every code here MUST exist in core's EXISTING_LOT_REASON_CODES - the API takes a GraphQL enum
// and then narrows it to that set, so anything else is refused. No "Other": this is the column
// the audit report groups on, and a free-text bucket defeats it.
const EXISTING_LOT_REASON_OPTIONS = [
  { code: 'NEW_SHIPMENT', label: 'New shipment of the same lot' },
  { code: 'MISSED_RECEIPT', label: 'Earlier arrival was never recorded' },
  { code: 'FACILITY_TRANSFER', label: 'Transferred from another facility' },
];

export default EXISTING_LOT_REASON_OPTIONS;
